import { maskCpf } from '@ibk/shared-utils';
import { useCnpjAlphanumeric } from './useCnpjAlphanumeric';
function getValueWithoutMask(value, isAlphanumericCNPJ) {
    if (!isAlphanumericCNPJ) {
        return value.replace(/\D/g, '');
    }
    return value.replace(/[^a-zA-Z0-9]/g, '');
}
export function useMaskCpfCnpj() {
    const { isAlphanumericEnabled, maskCnpj } = useCnpjAlphanumeric();
    function maskCpfCnpj(value) {
        const valueWithoutMask = getValueWithoutMask(value, isAlphanumericEnabled);
        const hasLetter = /[a-zA-Z]/.test(valueWithoutMask);
        if (hasLetter || valueWithoutMask.length > 11) {
            return maskCnpj(valueWithoutMask);
        }
        return maskCpf(valueWithoutMask, false);
    }
    return { maskCpfCnpj };
}
